<p-toast />
<div class="layout-centered">
  <p-card styleClass="card-style-account">
    <ng-template pTemplate="header">
      <img src="/assets/images/logo-redcurve.png" id="logo-redcurve" />
    </ng-template>


    <h1 class="h3">Verify Two-Factor Code</h1>
    <p>Please enter the code we have sent to your RCS account email or phone.</p>

    <form [formGroup]="twofaForm" (ngSubmit)="verifyCode()">
      <div class="field mb-2">
        <input pInputText id="code"
               formControlName="code"
               type="text"
               placeholder="Enter your code" />
      </div>

      <div class="field flex align-items-center mb-5">
        <p-checkbox id="remember2fa"
                    formControlName="remember2fa"
                    binary="true"
                    label="Remember this device" />
      </div>

      <div class="text-center mt-3">
        <p-button label="Previous" [outlined]="true" (click)="goBack()"></p-button>
        <p-button label="Verify" type="submit" [disabled]="twofaForm.invalid"></p-button>
      </div>
    </form>
  </p-card>

  <div class="centered-footer">
    <span>Copyright &copy; 2025</span> |
    <span>RedCurve Solutions &reg;</span> |
    <span>All Rights Reserved</span>
  </div>
</div>
